var render = function render(){var _vm=this,_c=_vm._self._c;return _c('map-view',{staticClass:"queclink-tracker-map",attrs:{"map-center":_vm.mapCenter}},[(_vm.lastKnownLocation?.location)?_c('o-map-square-marker',{attrs:{"label":_vm.label,"iconName":"map-marker","color":"blue","lat-lng":_vm.lastKnownLocation.location}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }